const styles = `:host button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--goto-text-01);
  gap: var(--goto-spacing-02);
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  box-sizing: border-box;
  font: var(--goto-body-small);
  border-radius: 15px;
  height: 30px;
  padding: 5px 12px;
  min-width: 80px;
  outline: none;
  background-color: var(--goto-disabled-02);
}
:host button ::slotted(span) {
  margin: 0 10px;
  pointer-events: none;
}
:host button ::slotted(chameleon-avatar) {
  height: 30px;
  width: 30px;
  font: var(--goto-avatar-30);
  --goto-icon-size: 20px;
  pointer-events: none;
  margin-left: -12px;
}
:host button ::slotted(chameleon-svg),
:host button ::slotted(svg) {
  height: var(--goto-spacing-05);
  width: var(--goto-spacing-05);
  --goto-icon-size: var(--goto-spacing-05);
  --goto-icon-color: var(--goto-text-02);
  color: var(--goto-text-02);
  margin-left: -4px;
  pointer-events: none;
}
:host button:hover {
  background-color: var(--goto-hover-02);
}
:host button:active {
  background-color: var(--goto-pressed-02);
  border: 0;
  box-shadow: none;
}
:host button:focus-visible {
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host button:-moz-focusring {
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host button .close {
  align-items: center;
  display: inline-flex;
  --goto-icon-size: 14px;
  --goto-icon-color: var(--goto-text-01);
}

:host([selected]) button .close,
:host([error]) button .close {
  --goto-icon-color: var(--goto-text-04);
}
:host([selected]) button ::slotted(chameleon-svg),
:host([selected]) button ::slotted(svg),
:host([error]) button ::slotted(chameleon-svg),
:host([error]) button ::slotted(svg) {
  --goto-icon-color: var(--goto-text-04);
  color: var(--goto-text-04);
}

:host([selected]) button {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  color: var(--goto-text-04);
  background-color: var(--goto-interactive-01);
  box-shadow: none;
}
:host([selected]) button:focus-visible {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([selected]) button:-moz-focusring {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([selected]) button:hover {
  background-color: var(--goto-hover-primary);
}
:host([selected]) button:active {
  background-color: var(--goto-pressed-primary);
}

:host([error]) button {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  color: var(--goto-text-04);
  background-color: var(--goto-danger-01);
  box-shadow: none;
}
:host([error]) button:focus-visible {
  background-color: var(--goto-danger-01);
  border-color: var(--goto-hover-danger);
  box-shadow: var(--goto-highlight-error);
}
:host([error]) button:-moz-focusring {
  background-color: var(--goto-danger-01);
  border-color: var(--goto-hover-danger);
  box-shadow: var(--goto-highlight-error);
}
:host([error]) button:hover {
  background-color: var(--goto-hover-danger);
}
:host([error]) button:active {
  background-color: var(--goto-pressed-danger);
}

:host([disabled]) button {
  color: var(--goto-text-03);
  background-color: var(--goto-disabled-01);
  cursor: default;
  border: 0;
  box-shadow: none;
}
:host([disabled]) button ::slotted(chameleon-avatar) {
  filter: opacity(0.2);
}
:host([disabled]) button .close,
:host([disabled]) button ::slotted(chameleon-svg),
:host([disabled]) button ::slotted(svg) {
  --goto-icon-color: var(--goto-text-03);
  color: var(--goto-text-03);
}
:host([disabled]) button:hover, :host([disabled]) button:active {
  color: var(--goto-text-03);
  background-color: var(--goto-disabled-01);
  cursor: default;
  border: 0;
  box-shadow: none;
}
:host([disabled]) button:focus-visible {
  color: var(--goto-text-03);
  background-color: var(--goto-disabled-01);
  cursor: default;
  border: 0;
  box-shadow: none;
}
:host([disabled]) button:-moz-focusring {
  color: var(--goto-text-03);
  background-color: var(--goto-disabled-01);
  cursor: default;
  border: 0;
  box-shadow: none;
}

:host([size=small]) button {
  height: 24px;
}
:host([size=small]) button ::slotted(span) {
  margin: 0 8px;
}
:host([size=small]) button ::slotted(chameleon-avatar) {
  height: 24px;
  width: 24px;
  font: var(--goto-avatar-24);
  --goto-icon-size: 1rem;
}
:host([size=small]) button ::slotted(chameleon-svg),
:host([size=small]) button ::slotted(svg) {
  height: var(--goto-spacing-04);
  width: var(--goto-spacing-04);
  --goto-icon-size: var(--goto-spacing-04);
}`; export default styles;